<!-- =========================================================================================
    File Name: ResetPassword.vue
    Description: Reset Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col sm:w-3/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/reset-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center  d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Reset Password</h4>
                                    <p>Please enter your new password.</p>
                                </div>
                                <!-- <vs-input type="email" label-placeholder="Email" v-model="value1" class="w-full mb-6" /> -->
                                <vs-input type="password" label-placeholder="Password" v-model="pass" class="w-full mb-6 " :danger="hasErrors"  @keyup.enter="reset"/>
                                <vs-input type="password" label-placeholder="Confirm Password" v-model="cPass" class="w-full mb-8" :danger="hasErrors" @keyup.enter="reset" />

                                <div class="flex flex-wrap justify-between flex-col-reverse sm:flex-row">
                                    <vs-button type="border" to="/pages/login" class="w-full sm:w-auto mb-8 sm:mb-auto mt-3 sm:mt-auto">Go Back To Login</vs-button>
                                    <vs-button class="w-full sm:w-auto" @click.native="reset">Reset</vs-button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import {getQueryVariable,clearAuth,$loading} from '@/assets/helper'
export default {
    data() {
        return {
            showErrors:false,
            pass: '',
            cPass: '',
        }
    },
    computed:{
        hasErrors(){
            let result = false
            if (this.pass.trim() && this.cPass.trim()){
                result = this.pass.trim() !== this.cPass.trim()
            }

            return result
        }
    },
    methods:{
        getQueryVariable,
        reset(){
            this.showErrors = false 

            let code = this.getQueryVariable('code')
            if (!code){
                return this.$vs.notify({
                    title: 'Error!',
                    text: 'Not a valid Token',
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    position:'bottom-center'
                })
            }
            
            if (this.hasErrors) return this.showErrors = true

            $loading()

            this.$api.post('/auth/reset-password',{
                code,
                password: this.pass,
                passwordConfirmation: this.cPass,
            }).then( ({data}) => {
                this.$router.push('/pages/login')
                notify({
                    time:4000,
                    title: 'Success',
                    text:`Your password was changed successfully`,
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-mail',
                    position:'bottom-center'
                })
            })
            .catch( () => {
                notify({
                    title: 'Error',
                    text:`An error occurred. Please try again.`,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    position:'bottom-center'
                })
            })
            .finally( () => {
                $loading.close()
            })


            



        }
    },
    created(){
        clearAuth(this.$store)
    }
}
</script>
